<template>
  <dropzone
    ref="mediaLibrary"
    id="dropzone"
    :options="dropzoneOptions"
    :useCustomSlot="true"
    @vdropzone-complete="handleCompleteUpload"
  >
    <div>
      <div class="dropzone-modern dz-square dz-clickable dropzone initialized">
        <span class="dropzone-upload-message text-center">
          <i class="bx bxs-cloud-upload"></i>
          <b class="text-color-primary">Prevucite/učitajte</b>
          slike ovdje.
          <span class="form-text">
            Učitajte slike rezolucije 800px x 800px
          </span>
        </span>
      </div>
    </div>
  </dropzone>
</template>

<script>
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import config from '@/config';
import { pager } from '@/mixins';

import { EventBus } from '@/main';

export default {
  name: 'MediaLibraryModalBody',
  mixins: [pager],
  components: {
    Dropzone,
  },
  props: {
    modalId: {
      type: String,
      default: 'upload-modal',
    },
  },
  data() {
    return {
      dropzoneOptions: config.appSettings.mediaLibrary,
    };
  },
  computed: {
    clearEventName() {
      return `clear-upload-modal-data:${this.modalId}`;
    },
  },
  methods: {
    handleCompleteUpload() {
      this.$store.dispatch('getMediaLibrary', this.searchConfig);
    },
    handleClearUploadModalData() {
      this.$refs?.mediaLibrary?.removeAllFiles();
    },
  },
  mounted() {
    EventBus.$on(this.clearEventName, this.handleClearUploadModalData);
  },
  beforeDestroy() {
    EventBus.$off(this.clearEventName, this.handleClearUploadModalData);
  },
  destroyed() {
    this.$refs?.mediaLibrary?.removeAllFiles()
  },
};
</script>

<style>
.dropzone .dz-preview {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 200px;
  margin: 0.5em;
}
</style>